import { render, staticRenderFns } from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=template&id=6b7e249c&scoped=true"
import script from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=style&index=0&id=6b7e249c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e249c",
  null
  
)

export default component.exports